import { RoleType } from '../../models/Role'
import { type CustomerSeats } from '../../store/plan/plan'

export type InviteSeatState =
  | { kind: 'unknown' }
  | { kind: 'available'; remaining: number }
  | { kind: 'shortage'; seatType: RoleType; canBuy: boolean }
  | { kind: 'notOffered' }

interface GetInviteSeatStateArgs {
  seats?: CustomerSeats
  seatType?: RoleType
  canBuy: boolean
  assistantOffered: boolean
}

export const getInviteSeatState = ({ seats, seatType, canBuy, assistantOffered }: GetInviteSeatStateArgs): InviteSeatState => {
  if (!seats || !seatType) {
    return { kind: 'unknown' }
  }

  const available = seatType === RoleType.SIDECAR ? seats.sidecar.available : seats.general.available

  if (available === 0) {
    if (seatType === RoleType.SIDECAR && !assistantOffered) {
      return { kind: 'notOffered' }
    }
    return { kind: 'shortage', seatType, canBuy }
  }

  return { kind: 'available', remaining: available - 1 }
}
